/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import {
  Label,
  Button,
} from 'semantic-ui-react';
import deleteIcon from '../../images/components/contnets_header/delete-icon-red.svg';
import searchIcon from '../../images/components/contnets_header/searchIcon.png';
import JiraLogo from '../../images/icons/jira/jira_origin.svg';

class SettingContentsHeaderByPolicys extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errSearch: false,
      isFocus: false,
      policyFilter: '',
    };
    this.changePolicyFilter = this.changePolicyFilter.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.addNewPolicy = this.addNewPolicy.bind(this);
    this.addNewIssue = this.addNewIssue.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { policyListLength, state } = this.props;

    if (policyListLength !== prevProps.policyListLength) {
      state.user.getsPolicyCount();
    }
  }

  handleSearch(event) {
    if (event.key === 'Enter') {
      if (event.target.value === '' || event.target.value.length < 2) {
        this.setState(
          {
            errSearch: true,
            isFocus: false,
          },
          () => {
            setTimeout(() => {
              this.setState({
                errSearch: false,
                isFocus: true,
              });
            }, 1500);
          }
        );
        return false;
      }
      setTimeout(() => {
        this.setState({
          isFocus: false,
        });
      }, 1500);
      this.props.onChangeSearch(event.target.value);
    }
  }

  handleFocus() {
    this.setState({
      isFocus: true,
    });
  }

  handleBlur() {
    this.setState({
      isFocus: false,
    });
  }

  deleteBtn = () => {
    const { translate } = this.props;
    return (
      <a
        className="delete_button util_button"
        style={{ cursor: 'pointer' }}
        onClick={this.props.deletePolicy}
        onKeyUp={this.props.deletePolicy}
      >
        <span>
          <img src={deleteIcon} alt="" style={{ width: '12px' }} />
        </span>
        {translate('modal.button.delete')}
      </a>
    );
  };

  changePolicyFilter = (e) => {
    const { translate } = this.props;
    let newValue;
    switch (true) {
    case e.target.text.indexOf(translate('project.menu.component')) > -1:
      newValue = 'component';
      break;
    case e.target.text.indexOf(translate('project.menu.security')) > -1:
      newValue = 'security';
      break;
    case e.target.text.indexOf(translate('project.menu.license')) > -1:
      newValue = 'license';
      break;
    case e.target.text.indexOf(translate('project.menu.litigator')) > -1:
      newValue = 'litigator';
      break;
    default:
      newValue = '';
      break;
    }
    this.setState({
      policyFilter: newValue,
    });
    this.props.changePolicyFilter(newValue);
  };

  clearSearch() {
    this.search.value = '';
    this.props.clearSearch();
  }

  addNewPolicy() {
    this.props.addNewPolicy();
  }

  addNewIssue() {
    this.props.addNewIssue();
  }

  render() {
    const { state, translate } = this.props;
    const {
      all, component, license, litigator, security
    } = state.user.policysCount;
    const { errSearch, isFocus, policyFilter } = this.state;

    return (
      <div className="contents_header">
        <div className="contents_header_inner">
          <div className="contents_tab">
            {all && all !== 0 ? (
              <a
                className={policyFilter === '' ? 'active_tab' : ''}
                onClick={this.changePolicyFilter}
              >
                {translate('contents_header.menu.all')}
                <em>{all}</em>
              </a>
            ) : null}
            {component && component !== 0 ? (
              <a
                className={policyFilter === 'component' ? 'active_tab' : ''}
                onClick={this.changePolicyFilter}
              >
                {translate('project.menu.component')}
                <em>{component}</em>
              </a>
            ) : null}
            {security && security !== 0 ? (
              <a
                className={policyFilter === 'security' ? 'active_tab' : ''}
                onClick={this.changePolicyFilter}
              >
                {translate('project.menu.security')}
                <em>{security}</em>
              </a>
            ) : null}
            {license && license !== 0 ? (
              <a
                className={policyFilter === 'license' ? 'active_tab' : ''}
                onClick={this.changePolicyFilter}
              >
                {translate('project.menu.license')}
                <em>{license}</em>
              </a>
            ) : null}
            {litigator && litigator !== 0 ? (
              <a
                className={policyFilter === 'litigator' ? 'active_tab' : ''}
                onClick={this.changePolicyFilter}
              >
                {translate('project.menu.litigator')}
                <em>{litigator}</em>
              </a>
            ) : null}
          </div>
          <div className="util_wrap">
            <div className="util_item ">
              <div className="search_files_wrap">
                <img src={searchIcon} alt="" className="icon" />
                <input
                  type="search_files"
                  className="seach_text"
                  placeholder={translate('settings.list.policy_name')}
                  ref={(ref) => {
                    this.search = ref;
                  }}
                  onKeyPress={this.handleSearch}
                  onFocus={this.handleFocus}
                  onBlur={this.handleBlur}
                />
                <a className="reset_icon" onClick={this.clearSearch} onKeyUp={this.clearSearch}>
                  x
                </a>
                {errSearch && (
                  <Label basic color="red" pointing>
                    {translate('contents_header.message.least_two_required_to_search')}
                  </Label>
                )}
                {isFocus && <Label pointing>{translate('settings.list.policy_name')}</Label>}
              </div>
            </div>
            <div className="button_wrap util_item">
              <Button
                className="jira"
                onClick={this.addNewIssue}
                onKeyUp={this.addNewIssue}
              >
                <span className="icon-wrap">
                  <img className="icon-jira" src={JiraLogo} alt="" />
                </span>
                {translate('settings.list.create_jira_issue')}
              </Button>
            </div>
            {this.props.state.user.isAdmin ? (
              <div className="button_wrap util_item">{this.deleteBtn()}</div>
            ) : null}
            {this.props.state.user.isAdmin ? (
              <div className="button_wrap util_item">
                <a
                  className="add_button util_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.addNewPolicy}
                  onKeyUp={this.addNewPolicy}
                >
                  <span>+</span>
                  {translate('modal.button.add')}
                </a>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default inject('state')(observer(SettingContentsHeaderByPolicys));
